/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import { Spinner } from 'react-bootstrap'
import { KTSVG } from 'src/_metronic/helpers'
import { downloadTemplate } from 'src/api/modules/configuration/approval'

interface Props {
  type_approval: string
}

export const ButtonDownloadTemplate:FC<Props> = ({type_approval}) => {
  const {t} = useTranslation()

  const [loading, setLoading] = useState(false)

  const gettemplate = async () => {
    try {
      setLoading(true)
      const response = await downloadTemplate(type_approval);
      const href = URL.createObjectURL(response.data)

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `approavl_config_template.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      swal({
        title: t('Donwload Failed'),
        icon: 'error',
      })
    }
  }

  return (
    <button
        disabled={loading}
        className='btn btn-info me-2'
        title={t('Download Template')}
        onClick={() => gettemplate()}
    >
        {loading ? (
        <Spinner animation='border' variant='light' size='sm' /> 
        ) : 
        <KTSVG path='/media/icons/duotune/download.svg' />
        }
        {t('Download Template')}
    </button>
  )
}
